var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"apple float-left flex justify-center vertical-align borderRadius8",attrs:{"alt":"Sign Up Using Apple Auth"},on:{"click":function($event){return _vm.comingSoon()}}},[_c('i',[_vm._v("")]),_vm._v(" Sign up with Apple ")])}
var staticRenderFns = []

export { render, staticRenderFns }